.inboxItem {
  display: flex;
  align-items: flex-start;
  gap: var(--ant-margin-sm);
  box-sizing: border-box;
  width: 100%;
  padding: var(--ant-padding-sm) var(--ant-padding);
  cursor: pointer;
  border: none;
  border-left: 3px solid transparent;
  border-bottom: var(--ant-line-width) solid var(--ant-color-border-secondary);
  background: transparent;
  text-align: left;
  transition: background var(--ant-motion-duration-fast) ease;
}

.inboxItem:last-child {
  border-bottom: none;
}

.inboxItem:hover {
  background: var(--ant-control-item-bg-hover);
}

.inboxItem:focus-visible {
  outline: var(--ant-line-width-focus) solid var(--ant-color-primary-border);
  outline-offset: -2px;
}

.inboxItemUnread {
  background: var(--ant-color-primary-bg);
  border-left-color: var(--ant-color-primary);
}

.inboxItemUnread:hover {
  background: var(--ant-color-primary-bg-hover);
}

.iconCircle {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  font-size: var(--ant-font-size);
  flex-shrink: 0;
}

.itemBody {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
  flex: 1;
}

.itemHeader {
  display: flex;
  align-items: baseline;
  gap: var(--ant-margin-xs);
  min-width: 0;
}

.senderName {
  min-width: 0;
}

.itemContext {
  flex-shrink: 0;
  font-size: var(--ant-font-size-sm);
}

.itemText.itemText {
  margin-bottom: 0;
  font-size: var(--ant-font-size-sm);
  line-height: var(--ant-line-height-sm);
}

.itemTime {
  font-size: var(--ant-font-size-sm);
}

.unreadDot {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: var(--ant-color-primary);
  flex-shrink: 0;
  margin-top: var(--ant-margin-xxs);
}
